import useScreenSize from '../hooks/useScreenSize'
import useMarkerPosition from '../hooks/useMarkerPosition'
const LinearChart = ({
  values,
  colors,
  markerPosition,
  type,
  data
}) => {
  const containerClass = useScreenSize()
  const calculateMarkerPosition = useMarkerPosition(values, type, data)

  const getColor = (index) => {
    if (index >= colors.length) {
      return colors[colors.length - 1]
    }
    return colors[index]
  }

  return (
    <div className={`relative ${containerClass} h-3 flex bg-zinc-700`}>
      {colors.map((value, index) => (
        <div
          key={index}
          className={`h-full flex-shrink-0 ${
            index === 0 ? 'rounded-l-full' : ''
          } ${index === colors.length - 1 ? 'rounded-r-full' : ''}`}
          style={{
            flexBasis: '45px',
            backgroundColor: getColor(index)
          }}
        />
      ))}

      <div
        className='absolute top-0 transform -translate-x-1/2 -translate-y-1/2 bg-zinc-800 border-2 border-zinc-800 rounded-full'
        style={{
          left: `${calculateMarkerPosition}px`,
          top: '50%',
          width: '11px',
          height: '11px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <span className='text-xs font-bold text-neutral-400 mb-8'>
          {markerPosition}
        </span>
      </div>
    </div>
  )
}

export default LinearChart
